import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import ViewFactory from '@/Factories/ViewFactory';
import ViewFactoryTuple from '@/Factories/ViewFactoryTuple';

export default abstract class AsyncViewFactory extends ViewFactory implements IAsyncElementProvider, IAsyncTupleProvider<ViewFactoryTuple> {
    public getView(): JQuery<HTMLElement> {
        throw new Error(`'getView' is not supported in '${ this.constructor?.name ?? 'AsyncViewFactory' }'`);
    }

    public abstract getElementAsync(): Promise<JQuery<HTMLElement>>;

    public async getTupleAsync(): Promise<ViewFactoryTuple> {
        if (this.tuple)
            return this.tuple;

        const $view = await this.getElementAsync();
        this.tuple = new ViewFactoryTuple(this, $view);
        return this.tuple;
    }
}